const pools = [
  {
    name: "GMD-WETH",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 554404,
    fees: 0.3,
    lowBound: 0.00997,
    highBound: 0.09987,
    pairAddress: "0x0632742C132413Cd47438691D8064Ff9214aC216",
    tokenPriceIds: ["gmd-protocol", "ethereum"],
  },
  {
    name: "WETH-GND",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 576737,
    fees: 1,
    lowBound: 1.24,
    highBound: 20.9,
    pairAddress: "0x1edd8c76f74d816f7472be69b174fe7b3084221e",
    tokenPriceIds: ["ethereum", ""],
  },
  {
    name: "WETH-GMX",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 576773,
    fees: 0.3,
    lowBound: 18.46,
    highBound: 34.05,
    pairAddress: "0x1aEEdD3727A6431b8F070C0aFaA81Cc74f273882",
    tokenPriceIds: ["ethereum", "gmx"],
  },
  {
    name: "gDAI-gmUSD",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 579307,
    fees: 0.05,
    lowBound: 0.95,
    highBound: 1.05,
    pairAddress: "0xd353018ada2232dffa497129b6851329b1746ce6",
    tokenPriceIds: ["usdk", "usdk"],
  },

  {
    name: "gmdUSDC-gmUSD",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 576576,
    fees: 0.05,
    lowBound: 0.9,
    highBound: 1.04,
    pairAddress: "0x5b7b716BD20D049cCf915aF8de1ff5051DA4d1Bf",
    tokenPriceIds: ["usdk", "usdk"],
  },

  {
    name: "GNS-WETH",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 560027,
    fees: 0.3,
    lowBound: 0.0021,
    highBound: 0.007,
    pairAddress: "0xC91B7b39BBB2c733f0e7459348FD0c80259c8471",
    tokenPriceIds: ["gains-network", "ethereum"],
  },

  {
    name: "USDT-USDC",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 560090,
    fees: 0.01,
    lowBound: 0.995,
    highBound: 1.005,
    pairAddress: "0x8c9d230d45d6cfee39a6680fb7cb7e8de7ea8e71",
    tokenPriceIds: ["tether", "usd-coin"],
  },
  {
    name: "WBTC-WETH",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 560152,
    fees: 0.05,
    lowBound: 11.11,
    highBound: 17.68,
    pairAddress: "0x2f5e87c9312fa29aed5c179e456625d79015299c",
    tokenPriceIds: ["bitcoin", "ethereum"],
  },
  {
    name: "VELA-WETH",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 561032,
    fees: 0.3,
    lowBound: 0.0011,
    highBound: 0.0035,
    pairAddress: "0x0ce541eac2adf14c8eeeb36d588a5db21df9e6c6",
    tokenPriceIds: ["vela-token", "ethereum"],
  },
  {
    name: "MAGIC-WETH",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 561082,
    fees: 0.3,
    lowBound: 0.00043,
    highBound: 0.001,
    pairAddress: "0x59d72ddb29da32847a4665d08ffc8464a7185fae",
    tokenPriceIds: ["magic", "ethereum"],
  },
  {
    name: "BFR-WETH",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 576806,
    fees: 0.3,
    lowBound: 0.00007,
    highBound: 0.00024,
    pairAddress: "0x475e0e1dd13396718e73999d447e3f8f2fd121ec",
    tokenPriceIds: ["ibuffer-token", "ethereum"],
  },
  {
    name: "PENDLE-WETH",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 562950,
    fees: 0.3,
    lowBound: 0.00015,
    highBound: 0.00046,
    pairAddress: "0xdbaeb7f0dfe3a0aafd798ccecb5b22e708f7852c",
    tokenPriceIds: ["pendle", "ethereum"],
  },
  {
    name: "RDNT-WETH",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 563192,
    fees: 0.3,
    lowBound: 0.00016,
    highBound: 0.00038,
    pairAddress: "0x446bf9748b4ea044dd759d9b9311c70491df8f29",
    tokenPriceIds: ["radiant-capital", "ethereum"],
  },
  {
    name: "CHR-WETH",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 578715,
    fees: 1,
    lowBound: 0.00042,
    highBound: 0.000142,
    pairAddress: "0xbf30b73504ac4dfb022c4e6ee111839ca09b0d34",
    tokenPriceIds: ["the-open-network", "ethereum"],
  },
  {
    name: "WETH-ARB",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 580491,
    fees: 0.3,
    lowBound: 1150,
    highBound: 1500,
    pairAddress: "0x92c63d0e701CAAe670C9415d91C474F686298f00",
    tokenPriceIds: ["ethereum", "arbitrum"],
  },

  {
    name: "ARB-USDC",
    logo: ["/icons/sharky/SHARKY.png"],
    tokenID: 580524,
    fees: 0.3,
    lowBound: 1.18,
    highBound: 1.9,
    pairAddress: "0x81c48d31365e6b526f6bbadc5c9aafd822134863",
    tokenPriceIds: ["arbitrum", "usd-coin"],
  },
];

export default pools;
